(() => {
  'use strict';
  let data;
  try { data = JSON.parse(document.getElementById('se-sweet-catalogue')?.textContent || 'null'); }
  catch { return; }
  if (!data?.enabled) return;
  const safeImage = url => {
    if (typeof url!=='string' || !url.trim()) return '';
    try { const parsed = new URL(url, location.origin); return parsed.protocol === 'https:' ? parsed.href : ''; }
    catch { return ''; }
  };
  function safeLayout(value) {
    if (!value || !Array.isArray(value.box) || value.box.length!==4 || !value.box.every(Number.isFinite) || value.box[2]<=0 || value.box[3]<=0) return {};
    return {box:value.box, atlasRatio:Number.isFinite(value.atlasRatio) && value.atlasRatio>0 ? value.atlasRatio : 1, kind:value.kind==='clip'?'clip':'atlas', path:typeof value.path==='string'?value.path:'', elongate:value.elongate===true};
  }
  function valid(next) {
    return next?.version === 1 && next.enabled === true && next.complete === true &&
      String(next.productId) === String(data.productId) && Array.isArray(next.entries) &&
      Array.isArray(next.variants) && next.variants.length === 4 && next.variants.every(size =>
        /^\d+$/.test(String(size.id)) && Number.isInteger(size.picks) && size.picks > 0);
  }
  if (!valid(data)) {
    window.SE_SWEET_CATALOGUE = {invalid: true};
    return;
  }
  const entries = new Map();
  const container = document.createElement('div');
  container.id = 'se-catalogue-controls'; container.hidden = true;
  const form = document.createElement('form'); form.id = 'se-catalogue-form';
  const variantInput = document.createElement('input'); variantInput.type = 'hidden'; variantInput.name = 'id';
  const quantityInput = document.createElement('input'); quantityInput.type = 'hidden'; quantityInput.name = 'quantity'; quantityInput.value = '1';
  const select = document.createElement('select'); select.setAttribute('aria-label', 'Mix size');
  for (const size of data.variants) {
    const option = document.createElement('option'); option.value = size.value; option.textContent = size.value; select.append(option);
  }
  const selectedId = new URL(location.href).searchParams.get('variant');
  select.value = (data.variants.find(size => String(size.id) === selectedId) || data.variants.find(size => size.available) || data.variants[0]).value;
  container.append(select, form); form.append(variantInput, quantityInput);
  const groups = data.variants.map(size => {
    const group = document.createElement('div'); group.id = `se-catalogue-${size.id}`;
    group.dataset.validate = `required|min_s:${size.picks}|max_s:${size.picks}`;
    group.dataset.name = `properties[Choose Up To ${size.picks} Sweets]`;
    container.append(group);
    return group;
  });

  function update(next) {
    if (!valid(next)) throw new Error('The sweet catalogue could not be verified. Refresh before adding your mix.');
    entries.clear();
    for (const entry of next.entries) {
      if (typeof entry.id !== 'string' || !entry.id.startsWith('gid://shopify/Metaobject/') || !entry.name?.trim() || entries.has(entry.id)) continue;
      entries.set(entry.id, {...entry, layout:safeLayout(entry.layout), photo: safeImage(entry.photo), preview: safeImage(entry.preview), categories: Array.isArray(entry.categories) ? entry.categories : [], sizes: Array.isArray(entry.sizes) ? entry.sizes : []});
    }
    data = next;
    groups.forEach((group, index) => {
      const existing = new Map([...group.querySelectorAll('input')].map(input => [input.value, input]));
      for (const entry of entries.values()) {
        const input = existing.get(entry.id) || document.createElement('input');
        input.type = 'checkbox'; input.value = entry.id;
        const available = entry.available === true && entry.archived !== true && entry.sizes.includes(data.variants[index].weight) && !!entry.photo && !!entry.preview;
        input.classList.toggle('se-catalogue-unavailable', !available); input.disabled = !available;
        if (!available) input.checked = false;
        if (!input.parentElement) group.append(input);
        existing.delete(entry.id);
      }
      for (const input of existing.values()) input.remove();
    });
    changeSize();
  }

  function changeSize() {
    const index = data.variants.findIndex(size => size.value === select.value);
    if (index < 0) return;
    groups.forEach((group, i) => {group.hidden = i !== index;});
    variantInput.value = String(data.variants[index].id);
  }
  select.addEventListener('change', () => {
    changeSize();
    const url = new URL(location.href); url.searchParams.set('variant', variantInput.value); history.replaceState(null, '', url);
  });
  update(data);
  document.getElementById('MainContent').append(container);
  window.SE_SWEET_CATALOGUE = {
    select, form, groups, entries,
    get sizes() { return data.variants; },
    get group() { return groups.find(group => !group.hidden); },
    items() {
      const index = groups.findIndex(group => !group.hidden), weight = data.variants[index]?.weight;
      return [...groups[index].querySelectorAll('input')].map(input => {
        const item = entries.get(input.value);
        return {name: item.id, title: item.name, orderValue: item.legacyValues?.[weight] || item.legacy || item.name,
          catalogueId: item.id, url: item.photo, preview: item.preview, previewLayout: item.layout || {},
          categories: item.categories, order: item.order || 0, vegan: item.categories.includes('vegan'), input,
          available: !input.disabled};
      });
    },
    async refresh() {
      const url = new URL(`/products/${document.getElementById('se-sweet-catalogue').dataset.handle}`, location.origin);
      url.searchParams.set('view', 'se-catalogue'); url.searchParams.set('variant', variantInput.value);
      url.searchParams.set('_catalogue', String(Date.now()));
      const response = await fetch(url, {cache: 'no-store', headers: {Accept: 'text/html'}});
      if (!response.ok) throw new Error('We couldn’t check sweet availability. Nothing was added. Please try again.');
      const next = JSON.parse((await response.text()).trim());
      const count = entries.size;
      update(next);
      return count !== entries.size;
    }
  };
})();
